/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weekday: NonNullable<unknown>, weekend: NonNullable<unknown> }} Profile_Sleep_ValueInputs */

const en_us2_profile_sleep_value = /** @type {(inputs: Profile_Sleep_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} h on weekdays, ${i?.weekend} h at the weekend`)
};

const pt_br2_profile_sleep_value = /** @type {(inputs: Profile_Sleep_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} h na semana, ${i?.weekend} h no fim de semana`)
};

const es_419_profile_sleep_value = /** @type {(inputs: Profile_Sleep_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} h entre semana, ${i?.weekend} h el fin de semana`)
};

const pt_pt2_profile_sleep_value = /** @type {(inputs: Profile_Sleep_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} h durante a semana, ${i?.weekend} h ao fim de semana`)
};

const fr_fr2_profile_sleep_value = /** @type {(inputs: Profile_Sleep_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} h en semaine, ${i?.weekend} h le week-end`)
};

const de_de2_profile_sleep_value = /** @type {(inputs: Profile_Sleep_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} h unter der Woche, ${i?.weekend} h am Wochenende`)
};

const it_it2_profile_sleep_value = /** @type {(inputs: Profile_Sleep_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} h in settimana, ${i?.weekend} h nel weekend`)
};

/**
* | output |
* | --- |
* | "{weekday} h on weekdays, {weekend} h at the weekend" |
*
* @param {Profile_Sleep_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_sleep_value = /** @type {((inputs: Profile_Sleep_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Sleep_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_sleep_value(inputs)
	if (locale === "es-419") return es_419_profile_sleep_value(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_sleep_value(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_sleep_value(inputs)
	if (locale === "de-DE") return de_de2_profile_sleep_value(inputs)
	if (locale === "it-IT") return it_it2_profile_sleep_value(inputs)
	return en_us2_profile_sleep_value(inputs)
});
export { profile_sleep_value as "profile.sleep_value" }